import PropTypes from 'prop-types';
import { useState } from 'react';

const CloseIcon = () => (
  <svg width={24} height={24} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27 15L15 27M15 15L27 27M41 21C41 32.0457 32.0457 41 21 41C9.9543 41 1 32.0457 1 21C1 9.9543 9.9543 1 21 1C32.0457 1 41 9.9543 41 21Z" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const Modal = ({ open, setOpen, children, autoClose, duration = 4000 }) => {
  const [stopTimeout, setStopTimeout] = useState(false);
  const toggle = () => setOpen(!open);
  
  if (open && autoClose && !stopTimeout) {
    setStopTimeout(true)
    setTimeout(() => {
      setOpen(false);
    }, duration);
  }
  return (
    <>
      <div id="my-modal" className={`modal ${open ? 'modal-open' : ''}`}>
        <div className="modal-box flex flex-col items-center text-center py-12 px-8 gap-2 relative">
          <i className="absolute top-3 right-4 cursor-pointer" onClick={toggle}><CloseIcon /></i>
          {children}
        </div>
      </div>
    </>
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export { Modal };